export default __webpack_public_path__ + "static/media/36.ee15452f.jpg";